import React, { forwardRef, PropsWithChildren } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const StyledCarouselWrapper = styled(Box)`
  ${s({
    width: '100%',
    px: 0,
    pb: 8,
    pt: 6,
    borderTop: '1px solid',
    borderColor: 'colorBorder03',
  })}
`

export const CarouselWrapper = forwardRef<HTMLDivElement, PropsWithChildren>(
  ({ children }, ref) => {
    return <StyledCarouselWrapper ref={ref}>{children}</StyledCarouselWrapper>
  },
)

CarouselWrapper.displayName = 'CarouselWrapper'
